<app-custom-title
    title="Facturas"
    icon="inventory.svg"
></app-custom-title>

<mat-dialog-content class="dialog-content">
  <div class="facturas">
    <h3 class="usage-title">Facturas con estatus: {{ogData.status}}
      <button mat-icon-button (click)="_download()" matTooltip="Descargar" matTooltipPosition="above"><mat-icon>arrow_downward</mat-icon></button>
    </h3>
    @if (facturas.length>0) {
      @for (item of facturas; track $index) {
        <mat-card class="factura-card">
          <mat-card-title>{{item.serie}}-{{ item.folio }}</mat-card-title>
          <mat-card-content>
            <p><strong>Receptor:</strong> {{ item.receptorRFC }} - ({{ item.receptorNombre }})</p>
            <p><strong>Emisión:</strong> {{ item.fechaEmision | date:'dd/MM/yyyy HH:mm' }}</p>
            <p><strong>Vencimiento:</strong> {{ item.fechaVencimiento | date:'dd/MM/yyyy' }}</p>
            <p><strong>Total:</strong> {{ item.total | currency }}</p>
          </mat-card-content>
        </mat-card>
      }
    } @else {
      <div class="no-data-message">
          <p>No se encontraron facturas</p>
      </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="_close()">Cerrar</button>
</mat-dialog-actions>